/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class BackButton extends Component {
  @service
  router;

  fallbackRoute = null;
  fallbackModels = null;
  raised = true;
  iconSize = 16;

  @action
  goBack() {
    let hasQueryParams = this.router.currentURL.includes('?');
    let inAppIndex = window.navigation?.currentEntry?.index ?? 0;

    if (!hasQueryParams && inAppIndex > 0) {
      window.history.back();
    } else if (this.fallbackRoute) {
      const models = this.fallbackModels || [];
      this.router.transitionTo(this.fallbackRoute, ...models);
    }
  }
}
